/*** IMPORTS FROM imports-loader ***/
var define = false;

import { Observable, } from 'zen-observable-ts';
import 'symbol-observable';
var prototype = Observable.prototype;
var fakeObsSymbol = '@@observable';
if (!prototype[fakeObsSymbol]) {
    prototype[fakeObsSymbol] = function () { return this; };
}
export { Observable };
//# sourceMappingURL=Observable.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/observables/Observable.js
// module id = 203
// module chunks = 0